export const initialState = {
  activeTab: null,
  secondaryActiveTab: 1,
};

const tabsReducer = (state, action) => {
  const { type, payload } = action;
  let newState = { ...state };

  switch (type) {
    case "CHANGE_TAB":
      return {
        ...newState,
        activeTab: payload.activeTab,
      };
    case "CHANGE_SECOND_TAB":
      return {
        ...newState,
        secondaryActiveTab: payload.secondaryActiveTab,
      };
    default:
      return newState;
  }
};

export default tabsReducer;